var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 642,
    height: 186,
    viewBox: "0 0 642 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Container",
    x: 0,
    y: 112,
    width: 642,
    height: 62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_5972",
    x: 254.509,
    y: 19.746,
    width: 132.982,
    height: 132.982,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img-top",
    transform: "translate(-362 -53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 362, 53)",
    filter: "url(#Container)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container-2",
    "data-name": "Container",
    width: 618,
    height: 38,
    transform: "translate(12 117)",
    fill: "#f3f3f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9065",
    "data-name": "Grupo 9065",
    transform: "translate(590 53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985",
    "data-name": "Grupo 8985",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5907",
    "data-name": "Trazado 5907",
    d: "M61.52,54.815V77L34.76,83.081a3.2,3.2,0,0,0-2.541,3.1v44.567c0,38.351,24.26,72.774,61.1,86.691l31.9,12.049v-186l-60.87,8.171A3.232,3.232,0,0,0,61.52,54.815Z",
    transform: "translate(-32.219 -43.489)",
    fill: "#dfe0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5908",
    "data-name": "Trazado 5908",
    d: "M82.223,229.49l31.9-12.049c36.839-13.915,61.1-48.338,61.1-86.691V86.188a3.2,3.2,0,0,0-2.541-3.1L145.92,77V54.817a3.231,3.231,0,0,0-2.833-3.156L82.217,43.49Z",
    transform: "translate(10.779 -43.49)",
    fill: "#eaeaea"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12741",
    "data-name": "Grupo 12741",
    transform: "translate(625.509 81.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5970",
    "data-name": "Trazado 5970",
    d: "M348.723,16.383h0Z",
    transform: "translate(-291.232 -16.382)",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5971",
    "data-name": "Trazado 5971",
    d: "M352.224,42.672v0a5.414,5.414,0,0,0-3.348,9.888,2.393,2.393,0,0,1,.882,2.647c-.081.239-.16.808-.239,1.057-.459,1.4.586,3.47,2.069,3.47h.459c1.475,0,2.53-2.071,2.071-3.47-.1-.294-.191-1.215-.287-1.509a2.152,2.152,0,0,1,.77-2.413,4.923,4.923,0,0,0,2.391-5.708A5.383,5.383,0,0,0,352.224,42.672Z",
    transform: "translate(-294.329 20.188)",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -263.51, -28.75)",
    filter: "url(#Trazado_5972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5972-2",
    "data-name": "Trazado 5972",
    d: "M382.173,16.383a57.491,57.491,0,1,0,57.491,57.491v0A57.492,57.492,0,0,0,382.173,16.383Zm18.418,90.255H364.2a7.3,7.3,0,0,1-7.3-7.3V75.115a7.287,7.287,0,0,1,7.27-7.3V55.288c0-9.967,7.681-18.66,17.643-18.959,10.309-.308,18.765,8.365,18.765,18.489,0,.954-.569,2.815-1.444,3.188l-6.227,2.654V55.02c0-5.7-4.166-10.8-9.845-11.352a10.921,10.921,0,0,0-12,10.857V67.817h29.519a7.3,7.3,0,0,1,7.279,7.3l0,24.215A7.284,7.284,0,0,1,400.591,106.638Z",
    transform: "translate(-61.17 12.36)",
    fill: "#c00"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTop);
export default __webpack_public_path__ + "static/media/img-top.7ec8bd17d156d7527def1721932718f2.svg";
export { ForwardRef as ReactComponent };